import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const SiteContentContext = createContext({ content: {}, menu: [], settings: {}, reload: () => {} });

export function SiteContentProvider({ children }) {
  const [content, setContent] = useState({});
  const [menu, setMenu] = useState([]);
  const [settings, setSettings] = useState({});

  const reload = useCallback(async () => {
    try {
      const [c, m, s] = await Promise.all([
        api.get("/content"), api.get("/menu"), api.get("/settings"),
      ]);
      setContent(c.data || {});
      setMenu(m.data || []);
      setSettings(s.data || {});
    } catch (e) {
      // swallow — defaults will be used
    }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  return (
    <SiteContentContext.Provider value={{ content, menu, settings, reload }}>
      {children}
    </SiteContentContext.Provider>
  );
}

export const useSite = () => useContext(SiteContentContext);
